/*
 * @Author: your name
 * @Date: 2021-08-31 09:29:16
 * @LastEditTime: 2023-08-25 17:47:21
 * @LastEditors: bobo 350910378@qq.com
 * @Description: In User Settings Edit
 * @FilePath: \baishu_react_ui\src\index.jsx
 */
import React from 'react';

import errorSystem_light from "../images/errorSystem_light.png";
import { setPageTitle } from './setPageTitle';

//异常捕获
export default class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: false,
            error: '',
            stack: '',
        };
    }


    reportError = () => {
        const { error, stack } = this.state;
        setPageTitle(React.language('page.error.tip'));
        var data = {
            type: 'js-logs',
            logtype: 'react-pc',
            name: document.title,
            url: window.location.href,
            ua: window.navigator.userAgent,
            info: {
                message: error.message,
                stack: error.stack,
                // stack: stack.componentStack,
            }
        };
        React.axios("/api/getparam.php", data).then(res => {

        })
    }

    componentDidCatch(error, stack) {
        console.error('ErrorBoundary componentDidCatch', error, stack)

        this.setState({
            hasError: true,
            error,
            stack
        }, () => {
            this.reportError();
        });
    }

    render() {
        if (this.state.hasError) {
            // return null
            // 也可以在出错的component处展示出错信息
            return (<div className="bsy-error-pane" style={{}}>
                <div className="bsy-error-content">
                    <img className="" src={errorSystem_light} alt="" ></img>
                    <div className="error-msg">
                        {
                            React.language('page.error.tip')
                        }
                    </div>
                </div>
            </div>)
        }
        return this.props.children;
    }
}
